import ToasterSnackbar from 'components/alert';
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ToasterState {
  open: boolean;
  message: string;
  severity: 'success' | 'info' | 'warning' | 'error';
}

interface ToasterContextType {
  toaster: ToasterState;
  showToaster: (severity: ToasterState['severity'], message: string) => void;
  closeToaster: () => void;
}

const ToasterContext = createContext<ToasterContextType | undefined>(undefined);

export const ToasterProvider = ({ children }: { children: ReactNode }) => {
  const [toaster, setToaster] = useState<ToasterState>({
    open: false,
    message: '',
    severity: 'info'
  });

  const showToaster = (severity: ToasterState['severity'] = 'info', message: string) => {
    setToaster({ open: true, message, severity });
  };

  const closeToaster = () => {
    setToaster((prev) => ({ ...prev, open: false }));
  };

  return (
    <ToasterContext.Provider value={{ toaster, showToaster, closeToaster }}>
      {children}
      <ToasterSnackbar
        open={toaster.open}
        severity={toaster.severity}
        message={toaster.message}
        onClose={closeToaster}
      />
    </ToasterContext.Provider>
  );
};

export const useToaster = (): ToasterContextType => {
  const context = useContext(ToasterContext);
  if (!context) throw new Error('useToaster must be used within ToasterProvider');
  return context;
};
